module.exports = __webpack_public_path__ + "media/images/footer_insta-a2a50cdc7786728c9f08c98c1a9a6dbe.svg";